import styled from '@emotion/styled'
import { clientActionPermissionsReportRequest } from 'api'
import { Locale, Translation } from 'locale'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { createOrganisationTradingEntityListSelector } from 'selectors/tradingEntitySelectors'
import { createUsersListByOrganisationIdGetterSelector } from 'selectors/userSelectors'
import { useParametricSelector } from 'utils'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { ModalContent, ModalFooter, ModalWindow } from 'view/components/panels'
import { OrganisationSelectboxField } from 'view/shared/entity'
import { ClonedComponentByShowModal } from 'view/shared/modal'
import { ACCENT_BAD } from 'view/styles/constants'

const WarningText = styled.span`
  padding-top: 1rem;
  padding-bottom: 1 rem;
  color: ${ACCENT_BAD};
  word-break: break-word;
`

const Content = styled(ModalContent)`
  height: 10rem;
  width: 35rem;
`

const MAX_ITEMS = 50

const getTradingEntitiesSelector = createOrganisationTradingEntityListSelector((_, id: string) => id)

export const PermissionsReportDialog: React.FC<ClonedComponentByShowModal> = ({ onClose }) => {
  const [organisationId, setOrganisationId] = useState<string | null>(null)
  const dispatch = useDispatch()
  const getUsersIds = useSelector(createUsersListByOrganisationIdGetterSelector)
  const usersIds = getUsersIds(organisationId)
  const tradingEntitiesIds = useParametricSelector(getTradingEntitiesSelector, organisationId)

  const shouldDisplayWarning = tradingEntitiesIds.length >= MAX_ITEMS || usersIds.length >= MAX_ITEMS

  return (
    <ModalWindow title={Locale.translate(Translation.TC_PERMISSIONS_REPORT)}>
      <Content>
        <OrganisationSelectboxField
          dataTestId="DealExportDumpDialog-OrganisationSelectboxField"
          label={Locale.translate(Translation.SC_ORGANISATION)}
          onUpdate={value => setOrganisationId(value)}
          value={organisationId}
          fieldName="organisationId"
        />
        {shouldDisplayWarning && (
          <WarningText>{Locale.translate(Translation.SC_PERMISSIONS_REPORT_WARNING, { maxItems: MAX_ITEMS })}</WarningText>
        )}
      </Content>
      <ModalFooter>
        <TextButton type={TextButtonType.Secondary} onClick={onClose}>
          {Locale.translate(Translation.TC_BUTTON_CANCEL)}
        </TextButton>
        <TextButton
          type={TextButtonType.Primary}
          disabled={!organisationId}
          onClick={() => {
            organisationId && dispatch(clientActionPermissionsReportRequest(organisationId))
            onClose?.()
          }}>
          {Locale.translate(Translation.TC_BUTTON_OK)}
        </TextButton>
      </ModalFooter>
    </ModalWindow>
  )
}
